// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthPage_root__1nHXx","backgroundContainer":"AuthPage_backgroundContainer__3GC9k","header":"AuthPage_header__3aVpe"};